export default {
  entrar: "Login",
  senha: "Password",
  informe: "Provide",
  nome: "Name",
  cadastro: "Sign up",
  "cadastre-se": "Sign up",
  cadastrar: "Submit",
  "cadastro-sucesso":
    "Sign up successful. Check your inbox for a verification link.",
  "redefinir-senha": "Password Reset",
  "senhas-diferentes": "Passwords do not match",
  "confirma-senha": "Password confirmation",
  "verifique-seu-email": "Check your inbox",
  "senha-redefinida-sucesso": "Password successfully reset",
  enviar: "Send",
  voltar: "Back",
  "email-invalido": "The e-mail address is invalid",
  "cpf-invalido": "CPF is invalid",
  "erro-api": "Something went wrong. Please try again.",
  "erro-estimativa-valor":
    "Error while estimating the value of the analysis. Please try again",
  "selecionar-todos": "Select All",
  "expandir-todos": "Expand All",
  "ocultar-todos": "Collapse All",
  "valor-base": "Base Value",
  "subtotal-area": "Area Subtotal",
  "subtotal-documentos": "Document Subtotal",
  desconto: "Discount",
  total: "Total",
  "executar-analise-erro": "Error creating report. Please try again.",
  "executar-analise-sucesso": "Report successfully created!",
  "detalhes-consulta": "Report details:",
  municipio: "Municipality",
  area: "Area",
  "area-ha": "Area (ha)",
  "area-consultada": "Queried Area",
  legenda: "Legend",
  Documento: "{num, plural, one {CPF/CNPJ} other {CPFs/CNPJs}}",
  criterios: "Criteria",
  "ajuda-criterios-1":
    "According the data provided, we have selected available criteria for analysis.",
  "ajuda-criterios-2":
    "You must select at least one criterion for analysis. To the right of each criterion, you can see the price by hectare or document.",
  "ajuda-criterios-3":
    "Below the criteria list, you can find the total value by hectare and document for this report, as well as the total value of the report.",
  "nome-consulta": "Report Name",
  "codigo-consulta": "Report Code",
  "ajuda-nome-consulta": "Optionally, you can provide a name for your report.",
  Executar: "Execute",
  Salvar: "Save",
  "ajuda-executar-analise-1": "To create a single report, you can select ",
  "ajuda-executar-analise-2":
    "If you want to generate multiple reports and execute them all at once, you can save this report.",
  "erro-inesperado-upload":
    "Unexpected error while uploading file. Please check your file and try again.",
  "mensagem-input-analise":
    "Provide the documents and/or area file to base the report on. The price for each report is {analysisBudget}.",
  "mensagem-input-analise-empresarial":
    "Provide the documents and/or area file to base the report on.",
  "relatorios-empresariais":
    "Reports",
  "filtrar-por-usuario":
    "Filter by user",
  "selecione-um-ou-mais":
    "Select one or more",
  "selecione-um":
    "Select one",
  "solicitante-consulta": "Requester",
  "procure-por-nome": "Search by name",
  "mensagem-intro-video": "Learn how to use BusCAR",
  "titulo-intro-video": "How to use BusCAR",
  "erro-documento-invalido":
    "We could not validate the following {num, plural, one {document} other {documents}}",
  "ajuda-analise-documento":
    "You can add multiple CPFs and CNPJs. If you already have a list, you can copy and paste the values separated by comma or semicolon",
  "titulo-cpf-dap": "Please enter the birth data of the CPF provided:",
  "dap-data-formatos": "Valid formats DD/MM/YYYY, DD-MM-YYYY or DD.MM.YYYY.",
  "error-data-dap": "Invalid date. Format must be DD/MM/YYYY, DD-MM-YYYY, or DD.MM.YYYY.",
  "e-ou": "and/or",
  "ou": "or",
  Enviando: "Uploading",
  "adicionar-arquivo": "Add File",
  "aceitamos-formatos": "We accept files in the following formats:",
  "primeira-opcao-recibo": "Option 1: Linking the CAR by receipt, use the formats:",
  "segunda-opcao-formatos": "Option 2: Linking the CAR by File:",
  "recibo-car": "CAR Receipt",
  "recibo-car-invalido": "INVALID CAR receipt! \n Please try again.",
  "recibo-car-erro": "Error linking CAR Receipt. \n Please try again.",
  "primeira-opcao-recibo-formato": "PA-XXXXXXX-XXXXXXXXXXXXXXXXXXXXXXXXXXXXXXXX",
  "segunda-opcao-recibo-formato": "PA-XXXXXXX-XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX.XXXX",
  "baixar-template": "Download Template",
  "formato-shapefile": "Shapefile, zipped ({link})",
  "formato-kml": "Kml ({link})",
  "formato-sicar":
    "{link}, zipped (SICAR is the CAR - Cadastro Ambiental Rural/Rural Ambiental Cadaster - system of the Serviço Florestal Brasileiro - Brazilian Florestal Service)",
  "um-arquivo-por-consulta": "You can only upload one file per report.",
  continuar: "Continue",
  "erro-verificar-saldo":
    "Error while verifying available balance. Please try again.",
  "saldo-insuficiente": "Insufficient balance to execute the report.",
  "nao-encontrado": "Not Found",
  "nao-encontrado-mensagem": "We could not find the page you are looking for.",
  "tente-voltar": "Try going back to the ",
  "pagina-inicial": "main page",
  "pagina-login": "login page",
  "remover-arquivo": "Remove File",
  "vincular-recibo": "Link the CAR Receipt",
  "resultado-consulta": "Analysis Results",
  "data-base": "Criterion Date",
  "data-consulta": "Report Date",
  "ultima-atualizacao": "Last Update",
  valor: "Price",
  'mudancas-termos': "Updates to our Terms and Privacy Policy.",
  'mudancas-termos-descricao': "The terms are being updated to better suit the new LGPD (General Data Protection Law). To continue using our system, you will need your consent to the new terms and policies.",
  "nenhuma-infracao": "No overlap found",
  "infracoes-encontradas": "Overlap found",
  "porcentagem-sobreposicao": "Overlap percentage",
  "nenhuma-infracao-documento": "No occurrences found",
  "x-ocorrencias-encontradas": "{num} occurrence(s) found",
  "cpfs-com-dap": "CPFs with DAP",
  "sem-titulo": "Untitled",
  "area-intersecao": "Overlapping Area",
  "consulta-pronaf": "Do you have a Declaration of Eligibility for Pronaf (DAP)?",
  "ajuda-pronaf": "You can identify if the operation is Pronaf",
  "documentos-com-problemas": "CPFs",
  "documentos-sem-problemas": "CPFs without occurrences",
  descricao: "Description",
  fonte: "Source",
  "mensagem-processando-consulta":
    "Your analysis is still being processed. Some criteria may take up to a few hours to process.",
  "tipos-criterio": "Criteria Types",
  "pagina-anterior": "Previous Page",
  "proxima-pagina": "Next Page",
  "nenhuma-consulta-encontrada": "No reports found",
  historico: "History",
  "nova-consulta": "New Analysis",
  sobre: "About",
  "termos-uso": "Terms of Use",
  "politica-privacidade": "Privacy Policy",
  contato: "Contact",
  sair: "Logout",
  "possui-criterio-documento": "has document criteria",
  "possui-criterio-area": "has area criteria",
  "li-e-aceito": "I have read and accept the",
  "e-a": "and the",
  "validar-conta": "Validate Account",
  "sucesso-validacao-email": "Successfully validated account",
  "erro-validacao-email": "There was a problem validating your account",
  sucesso: "Success",
  erro: "Error",
  "sera-cobrado": "You will be charged",
  "confirmacao-relatorio": "Report Confirmation",
  processada: "Processed",
  "nao-processada": "Not processed",
  sim: "Yes",
  nao: "No",
  cancelar: "Cancel",
  "executar-analise": "Execute Analysis",
  "executar-selecionadas": "Execute Selected",
  "executadas-sucesso":
    "{num} {num, plural, one {analysis} other {analyses}} successfully executed",
  "executadas-erro":
    "{num, plural, one {An error occurred while executing the analysis} other {{num} errors occurred while executing the analyses}}:",
  "exportar-como-pdf": "Export as PDF",
  endereco: "Address",
  fone: "Phone",
  "mensagem-home-office-telefone": "We are working from home, call us at",
  "horario-atendimento": "Hours",
  "horario-atendimento-descricao": "from {de} to {ate}, Belem timezone (UTC-3)",
  "mensagem-sobre-1":
    "BusCAR is a web application to consult the social and environmental situation of rural properties registered on the Cadastro Ambiental Rural (CAR) or any area of your interest in the Brazilian territory, in a practical and fast way.",
  "mensagem-sobre-2":
    "The application has a list of social and environmental criteria required by financial institutions, agribusiness market, and by the growing number of conscious consumers.",
  "perguntas-frequentes": "Frequently Asked Questions",
  fechar: "Close",
  "ir-para-contato": "Go to the contact page.",
  todos: "All",
  personalizado: "Custom",
  "bases-disponiveis": "Available Bases",
  "usuarios-unicos": "Unique users",
  "usuarios-consultas": "Users with queries",
  "consultas": "Total queries",
  "consultas-normais": "Normal queries",
  "consultas-empresariais": "Enterprise queries",
  "contas-antes-lancamento": "Accounts before launch",
  "contas-pos-lancamento": "Accounts post launch",
  "filtrar-por-data": "Filter by date",
  "ate": "to",
  "todos-usuarios": "All users",
  "vincular-usuario-pj": "Link user to PJ",
  "grafico": "Graph",
  "usuarios": "Users",
  "entrou-em": "Signed up in",
  "numero-total-consultas": "Total queries made",
  "primeira-consulta": "First query",
  "ultima-consulta": "Last query",
  "sem-consulta": "No queries",
  "consultas-feitas": "Made queries",
  "consultas-restantes": "Remaining queries",
  "total-usuarios": "Total users linked",
  "informacoes": "Informations",
  "conta-pj-master": "Master PJ account",
  "conta-pj-direta": "Direct PJ account",
  "plano-atual": "Actual plan",
  "dia-bilhetagem": "Ticketing day",
  "historico-consultas": "Queries history",
  "consultas-mensais": "monthly queries",
  "tolerancia": "tolerance",
  "administrador": "Administrator",
  "confirmacao-reenvio": "Resend Confirmation",
  "reenvio-email-usuario": "Resend confirmation email of user {email}",
  "exportar-coordenadas": "Coordinates in CSV",
  "saldo": "Balance",
  "processando-pagamento": "Processing Payment",
  "verificando-status-pagamento": "Verifying your payment status...",
  "carregando": "Loading...",
  "pagamento-realizado": "Payment Successful!",
  "pagamento-confirmado": "Payment Confirmed!",
  "pagamento-sucesso-mensagem": "Your payment has been successfully processed. The credits have been added to your account and you can now use them.",
  "nota": "Note:",
  "pagamento-info-boleto-pix": "For payments via boleto or PIX, credits will be added after payment confirmation by the bank, which may take a few minutes.",
  "nova-analise": "New Analysis",
  "adicionar-fundos": "Add Funds"
};
